<template>
  <div class="left-menu">
    <template v-if="curSysKey === 'course'">
      <div class="logo-content" v-if="isCollapse" @click="goIndex"><div class="name">儿童中心</div></div>
      <div class="logo-content" v-else @click="goIndex"></div>
    </template>
    <template v-else>
      <div class="logo-content community" v-if="isCollapse" @click="goIndex"><div class="name">应用管理</div></div>
      <div class="logo-content community" v-else @click="goIndex">App管理后台</div>
    </template>
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="true"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item
          v-for="route in tempMenu"
          :key="route.path"
          :item="route"
          :base-path="route.path"
          :activeMenu="activeMenu"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Menu, Scrollbar } from 'element-ui';
import utils from '@/utils';
import variables from '@/assets/style/global.less';
import SidebarItem from './SidebarItem';

export default {
  name: 'Sidebar',
  components: { SidebarItem, ElScrollbar: Scrollbar, ElMenu: Menu },
  methods: {
    goIndex() {
      if (utils.isCourse(this.curSysKey)) {
        this.$router.push(`/${this.user_id}${utils.COURSE_INDEX_PATH}`);
      } else {
        this.$router.push(`/${this.user_id}${utils.COMMUNITY_INDEX_PATH}`);
      }
    }
  },
  computed: {
    ...mapGetters(['sidebar', 'tempMenu']),
    activeMenu() {
      const { meta, path } = this.$route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      const reg = new RegExp(`/${this.user_id}`);
      return path.replace(reg, '');
    },
    user_id() {
      return this.$route.params.user_id;
    },
    curSysKey() {
      return this.$store.state.app.curSysKey;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    }
  }
};
</script>
